var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_88",
    "data-name": "\\u6955\\u5186\\u5F62 88",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_2106",
    "data-name": "\\u30D1\\u30B9 2106",
    d: "M136.336,44.419v2.119a.606.606,0,0,0,.606.606h2.119a.61.61,0,0,0,.429-.177l8.6-8.6-2.976-2.976-8.6,8.6A.6.6,0,0,0,136.336,44.419Zm13.945-8.241a.946.946,0,0,0,0-1.339h0l-1.637-1.64a.948.948,0,0,0-1.34,0l-1.341,1.342,2.976,2.976Z",
    transform: "translate(-128.336 -24.921)",
    fill: "#A59785"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f3026f84b41ef36d4c4f70daf09c9879.svg";
export { ForwardRef as ReactComponent };